module.exports = __webpack_public_path__ + "img/p5-1.57d8ebff.png";